import { isTypePerson, TypePersonSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulSmallLinkCta from './ContentfulSmallLinkCta';

const ContentfulPerson = ({
  entry,
}: {
  entry: Entry<TypePersonSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypePerson(entry)) {
    return null;
  }

  return (
    <div className='flex flex-col sm:flex-row gap-3 sm:gap-5 items-center text-center'>
      {entry.fields.image && (
        <img
          // TODO: image placement is still slightly off; is that OK?
          className='rounded-full w-40 h-40 sm:w-48 sm:h-48 shrink-0 bg-cover bg-center object-cover'
          src={entry.fields.image.fields.file?.url}
          alt={entry.fields.image.fields.title}
        />
      )}
      <div className='flex flex-col gap-3 sm:text-left'>
        <h2 className='font-header text-2xl sm:text-4xl leading-7 text-gray-500 font-semibold'>
          {entry.fields.firstName} {entry.fields.lastName}
        </h2>
        <div className='font-header text-xl sm:text-2xl leading-6 text-gray-400 font-medium'>
          {entry.fields.profession}
        </div>
        {entry.fields.description}
        <ContentfulSmallLinkCta entry={entry.fields.cta} />
      </div>
    </div>
  );
};

export default ContentfulPerson;
